// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Cart: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg"
     viewBox="0 0 424.449 424.449"
     fill="currentColor"
     focusable="false" width="24" height="24">
    <circle cx="170.241" cy="374.273" r="50.176"/>
    <path d="M316.673 324.098c-27.711 0-50.176 22.465-50.176 50.176s22.465 50.176 50.176 50.176c27.711 0 50.176-22.465 50.176-50.176s-22.465-50.176-50.176-50.176zM402.177 272.897H140.545l-5.12-29.696h215.04a15.36 15.36 0 0014.336-9.728l51.2-129.024c3.111-7.892-.766-16.812-8.658-19.922a15.349 15.349 0 00-5.678-1.07H108.801L96.513 12.801a15.36 15.36 0 00-15.36-12.8h-58.88c-8.483 0-15.36 6.877-15.36 15.36s6.877 15.36 15.36 15.36h46.08l44.032 260.096a15.36 15.36 0 0015.36 12.8h274.432c8.483 0 15.36-6.877 15.36-15.36s-6.877-15.36-15.36-15.36z"/>
</svg>;
};

export default React.memo(Cart);
